import type { ReactNode } from 'react';
import { ApiError } from '@/services/ApiError';
import { Alert } from './Alert';
import { Button } from './Button';
import { Card, CardBody } from './Card';

export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return <div role="status" aria-live="polite" className="py-12 text-center text-slate-500">{label}...</div>;
}

export function EmptyState({ title, children, action }: { title: string; children?: ReactNode; action?: ReactNode }) {
  return (
    <Card><CardBody className="py-12 text-center">
      <p className="font-medium text-slate-900">{title}</p>
      {children && <p className="mx-auto mt-1 max-w-md text-sm text-slate-600">{children}</p>}
      {action && <div className="mt-4">{action}</div>}
    </CardBody></Card>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const message = error instanceof ApiError ? error.message : 'Something went wrong.';
  const trace = error instanceof ApiError ? error.traceId : undefined;
  return (
    <Alert tone="error" title="We could not load that">
      {message}
      {trace && <span className="mt-1 block text-xs opacity-70">Reference: {trace}</span>}
      {onRetry && <div className="mt-2"><Button size="sm" variant="secondary" onClick={onRetry}>Try again</Button></div>}
    </Alert>
  );
}
